/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
import {Type} from 'class-transformer';
import moment, {Moment} from "moment";


export class BackendErrorContainerRes {
    statusCode!: number;

    @Type(() => ApiException)
    exception!: ApiException;

    @Type(() => ValidationErrorRes)
    data?: ValidationErrorRes;
}

export class ValidationErrorRes {
    @Type(() => FieldError)
    errors: FieldError[] = [];
}

export class FieldError {
    fieldName!: string;
    message!: string;
}

export class ApiException {
    errorCode!: number;
    message!: string;
}

export enum TranslationSource {
    AutoTranslated = 0,
    ManuallyTranslated = 1,
}

export class TranslationExtDto {
    private _updated: any;
    private _created: any;
    language!: string;
    value: string = "";
    autoTranslated!: TranslationSource;


    get updated(): any {
        return this._updated;
    }

    set updated(value: any) {
        this._updated = moment(value);
    }

    get created(): any {
        return this._created;
    }

    set created(value: any) {
        this._created = moment(value);
    }

}

export class TranslationRes {
    value!: string;

    /**
     * This property will only be set if this field is expanded.
     * See query param 'expandFields' in api docs
     * */
    @Type(() => TranslationExtDto)
    translations: TranslationExtDto[] = [];

    /**
     * To string overwrite. Will automatically display nested property 'value'.
     * Easier to use. Update model has different usage. Therefore, no problem to user overwrite
     * */
    public toString = (): string => {
        return this.value;
    }
}


export class TranslationReq {
    @Type(() => TranslationExtDto)
    translations: TranslationExtDto[] = [];

    constructor() {
    }

    public fill(supportedCultures: string[]) {
        for (let culture of supportedCultures) {
            let desc = new TranslationExtDto()
            desc.language = culture;
            this.translations.push(desc);
        }
    }
}
